var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOrders = function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.078 6.247H.285v-4.62c0-.428.36-.774.786-.774h14.277a.804.804 0 0 1 .56.227.762.762 0 0 1 .226.546v4.62h-.792v7.706a.75.75 0 0 1-.23.543.79.79 0 0 1-.557.227H1.865a.81.81 0 0 1-.558-.227.766.766 0 0 1-.23-.543V6.247Zm12.679 0H2.663v6.934h11.094V6.247ZM1.87 2.394v2.312h12.68V2.394H1.87Zm3.962 5.393h4.755v1.541H5.832v-1.54Z",
    fill: "#03053D"
  })));
};

export default SvgOrders;